// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-container {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: .5rem;
    cursor: pointer;
  }

  /* Alterando cor do background do Slide Toggle */
  ::ng-deep .mdc-switch .mdc-switch__track::before {
    background: #000000 !important;
  }
  ::ng-deep .mdc-switch .mdc-switch__track::after {
    background: #000000 !important;
  }

  /* Alterando cor da esfera do Slide Toggle */
  ::ng-deep .mdc-switch.mdc-switch--unselected:enabled .mdc-switch__handle::after {
    background: transparent !important;
    border: solid .1rem #000000;
  }

  ::ng-deep .mdc-switch.mdc-switch--selected:enabled .mdc-switch__handle::after {
    background: transparent !important;
    border: solid .1rem #000000;
  }

  /* Retirando icones de estilização padrão do Slide Toggle */
  ::ng-deep .mdc-switch.mdc-switch--selected:enabled .mdc-switch__icon {
    display: none;
  }

  ::ng-deep .mdc-switch.mdc-switch--unselected:enabled .mdc-switch__icon {
    display: none;
  }

  /* Alterando largura e altura do Slide Toggle */
  ::ng-deep .mdc-switch {
    --mdc-switch-handle-height: 15px !important;
    --mdc-switch-handle-width: 15px !important;
    --mdc-switch-track-height: 9px !important;
    --mdc-switch-track-width: 25px !important;
  }

  ::ng-deep .default-theme-icon .wallet-icon .border,
  ::ng-deep .default-theme-icon .co2-icon .border,
  ::ng-deep .default-theme-icon .wallet-icon .text,
  ::ng-deep .default-theme-icon .co2-icon .text {
    fill: var(--text);
  }

  /* Icones (Eco e Wallet) */
  ::ng-deep .selected-theme-icon .wallet-icon .background,
  ::ng-deep .selected-theme-icon .co2-icon .background {
    fill: #73E44B;
  }

  ::ng-deep .selected-theme-icon .co2-icon .border,
  ::ng-deep .selected-theme-icon .wallet-icon .border {
    fill: #62bf40;
  }

  ::ng-deep .default-theme-icon .wallet-icon .background,
  ::ng-deep .default-theme-icon .co2-icon .background {
    fill: transparent;
  }
`, "",{"version":3,"sources":["webpack://./src/app/shared/eco-cost-toggle/eco-cost-toggle.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;;EAEA,4CAA4C;EAC5C;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA,2DAA2D;EAC3D;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,+CAA+C;EAC/C;IACE,2CAA2C;IAC3C,0CAA0C;IAC1C,yCAAyC;IACzC,yCAAyC;EAC3C;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB","sourcesContent":[".switch-container {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    padding: .5rem;\n    cursor: pointer;\n  }\n\n  /* Alterando cor do background do Slide Toggle */\n  ::ng-deep .mdc-switch .mdc-switch__track::before {\n    background: #000000 !important;\n  }\n  ::ng-deep .mdc-switch .mdc-switch__track::after {\n    background: #000000 !important;\n  }\n\n  /* Alterando cor da esfera do Slide Toggle */\n  ::ng-deep .mdc-switch.mdc-switch--unselected:enabled .mdc-switch__handle::after {\n    background: transparent !important;\n    border: solid .1rem #000000;\n  }\n\n  ::ng-deep .mdc-switch.mdc-switch--selected:enabled .mdc-switch__handle::after {\n    background: transparent !important;\n    border: solid .1rem #000000;\n  }\n\n  /* Retirando icones de estilização padrão do Slide Toggle */\n  ::ng-deep .mdc-switch.mdc-switch--selected:enabled .mdc-switch__icon {\n    display: none;\n  }\n\n  ::ng-deep .mdc-switch.mdc-switch--unselected:enabled .mdc-switch__icon {\n    display: none;\n  }\n\n  /* Alterando largura e altura do Slide Toggle */\n  ::ng-deep .mdc-switch {\n    --mdc-switch-handle-height: 15px !important;\n    --mdc-switch-handle-width: 15px !important;\n    --mdc-switch-track-height: 9px !important;\n    --mdc-switch-track-width: 25px !important;\n  }\n\n  ::ng-deep .default-theme-icon .wallet-icon .border,\n  ::ng-deep .default-theme-icon .co2-icon .border,\n  ::ng-deep .default-theme-icon .wallet-icon .text,\n  ::ng-deep .default-theme-icon .co2-icon .text {\n    fill: var(--text);\n  }\n\n  /* Icones (Eco e Wallet) */\n  ::ng-deep .selected-theme-icon .wallet-icon .background,\n  ::ng-deep .selected-theme-icon .co2-icon .background {\n    fill: #73E44B;\n  }\n\n  ::ng-deep .selected-theme-icon .co2-icon .border,\n  ::ng-deep .selected-theme-icon .wallet-icon .border {\n    fill: #62bf40;\n  }\n\n  ::ng-deep .default-theme-icon .wallet-icon .background,\n  ::ng-deep .default-theme-icon .co2-icon .background {\n    fill: transparent;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
